import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import { ResidentLeadInterestUpdateModel } from './models';

export function validateInterestSurveyEntryService(
  interestUpdateToken: string,
  client: ApiClient = apiClient,
) {
  return client.head<void>(
    `/residents/leads/interest/${interestUpdateToken}/valid`,
  );
}

export function updateUserInterestSurveyService(
  interestUpdateToken: string,
  surveyInfo: ResidentLeadInterestUpdateModel,
  client: ApiClient = apiClient,
) {
  return client.put<void>(
    `/residents/leads/interest/${interestUpdateToken}`,
    surveyInfo,
  );
}

export function fetchApplicationStatusService(
  interestUpdateToken: string,
  client: ApiClient = apiClient,
) {
  return client.get<string>(
    `/residents/leads/interest/${interestUpdateToken}/application-status`,
  );
}
